export default "__VITE_ASSET__BwDl$JoZ__ 500w";